<template>
  <div>
    <div class="oficina-tabs">
      <button
        v-for="tab in step.tabs"
        :key="tab.id"
        class="oficina-tab"
        :class="{ active: activeTab === tab.id }"
        @click="updateTab(tab.id)"
      >
        <i :class="getIconClass(tab.icon)"></i> {{ tab.label }}
      </button>
    </div>
    <div class="oficina-tab-content">
      <div v-if="currentTab.list">
        <div class="challenges-banner">
          <p class="challenges-banner-text">{{ currentTab.content }}</p>
        </div>
        <div class="challenges-cards">
          <div v-for="(item, idx) in currentTab.list" :key="idx" class="challenge-card">
            {{ item }}
          </div>
        </div>
      </div>
      <div v-else-if="currentTab.sections">
        <div class="sections-grid">
          <div v-for="(section, idx) in currentTab.sections" :key="idx" class="section-card">
            <h4>{{ section.title }}</h4>
            <p>{{ section.text }}</p>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="toolkit-section">
          <h2 class="toolkit-title">Kit de Ferramentas</h2>
          <p class="toolkit-description">{{ currentTab.content }}</p>
        </div>
      </div>
    </div>
    <div v-if="step.tip" class="oficina-slide-tip">
      <i class="icofont-info-circle"></i> {{ step.tip }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabbedContentSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
    activeTabs: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    activeTab() {
      return this.activeTabs.sus || 'aps'
    },
    currentTab() {
      return this.step.tabs.find((t) => t.id === this.activeTab) || this.step.tabs[0]
    },
  },
  methods: {
    updateTab(tabId) {
      this.$emit('update-tab', 'sus', tabId)
    },
    getIconClass(icon) {
      if (icon === 'Info') return 'icofont-info-circle'
      if (icon === 'Users') return 'icofont-users-alt-4'
      if (icon === 'AlertCircle') return 'icofont-warning'
      if (icon === 'Wrench') return 'icofont-settings'
      return 'icofont-info-circle'
    },
  },
  emits: ['update-tab'],
}
</script>

<style scoped>
.oficina-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.oficina-tabs::-webkit-scrollbar {
  height: 6px;
}

.oficina-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.oficina-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.oficina-tabs::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.oficina-tab {
  padding: 12px 20px;
  border: 2px solid #e2e8f0;
  border-right: none;
  background: white;
  border-radius: 0;
  cursor: pointer;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.oficina-tab:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.oficina-tab:last-child {
  border-right: 2px solid #e2e8f0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.oficina-tab.active {
  background: #0FAFD7;
  border-color: #0FAFD7;
  color: white;
  z-index: 1;
  position: relative;
}

.oficina-tab.active + .oficina-tab {
  border-left-color: #0FAFD7;
}

.oficina-slide-text {
  font-size: 16px;
  line-height: 1.6;
  color: #1e293b;
  margin-bottom: 24px;
}

/* Challenges Banner (Amarelo) */
.challenges-banner {
  background: #fef3c7;
  padding: 20px 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  border: 1px solid #fde68a;
}

.challenges-banner-text {
  font-size: 15px;
  font-weight: 700;
  color: #92400e;
  margin: 0;
  line-height: 1.5;
}

/* Challenges Cards */
.challenges-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.challenge-card {
  background: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 15px;
  line-height: 1.6;
  color: #1e293b;
  transition: box-shadow 0.2s;
}

.challenge-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.sections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.section-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.section-card h4 {
  font-weight: 700;
  color: #1e40af;
  margin-bottom: 8px;
  font-size: 16px;
}

.section-card p {
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}

/* Toolkit Section */
.toolkit-section {
  text-align: center;
  padding: 40px 20px;
}

.toolkit-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 24px 0;
  line-height: 1.2;
}

.toolkit-description {
  font-size: 15px;
  line-height: 1.6;
  color: #64748b;
  margin: 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.oficina-slide-tip {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-top: 24px;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
</style>
